import { ajaxJson } from '../../imports/ajax';
import { 
    map2CourseObj,
    map2accessObj
} from 'imports/mapper';
import { courseActionCreators } from 'db/course/course.action';
import { createTypes } from 'redux-create-types';


const namespace = 'course';

export const courseActions = createTypes([
    'toggleSpinner',
    'setError',
    'setBreadCrumb',
    'setAccess',
    'toggleSearchState',
    'getUserInfoFromApi',
    'setUnSeenMessages',
    'setNotifList',
    'setNotifsCount',
    'toggleNotifsList',
    'hideNotifsList'
], namespace);

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: courseActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: courseActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}

function setBreadCrumb(items) {
    return dispatch => {
        dispatch({
            type: courseActions.setBreadCrumb,
            payload: items
        });
    }
}

function getCourseApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('course'));
    }
}

function getCourseApiSuccess(res) {
    return dispatch => {
        const courseObj = map2CourseObj(res.data);
        dispatch(courseActionCreators.save(courseObj))
    }
}

function getCourseFromApi(courseId) {
    return dispatch => {
        dispatch(showSpinner('course'));
        return ajaxJson.get(`/courses/${courseId}`)
        .then(
            res => dispatch(getCourseApiSuccess(res)),
            err => dispatch(getCourseApiFail(err)),
        ).then(() => {
            dispatch(hideSpinner('course'));
        })
    }
}

function getProgramCourseAccessApiSuccess(res) {
    return dispatch => {
        const accessObj = map2accessObj(res.data);
        dispatch({
            type: courseActions.setAccess,
            payload: accessObj,
        })
    }
}

function getProgramCourseAccessApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('program-course-access'));
    }
}

function getProgramCourseAccessFromApi(programId, courseId) {
    return dispatch => {
        dispatch(showSpinner('program-course-access'));
        return ajaxJson.get(`/programs/${programId}/courses/${courseId}/access`)
        .then(
            res => dispatch(getProgramCourseAccessApiSuccess(res)),
            err => dispatch(getProgramCourseAccessApiFail(err))
        )
        .then(() => {
            dispatch(hideSpinner('program-course-access'));
        })
    }
}

function toggleSearchState(isSearchState) {
    return dispatch => {
        dispatch({
            type: courseActions.toggleSearchState,
            payload: isSearchState,
        })
    }
}

function toggleNotifsList(payload) {
    return dispatch => {
        dispatch({
            type: courseActions.toggleNotifsList,
            payload: payload,
        })
    }
}

function hideNotifsList() {
    return dispatch => {
        dispatch({
            type: courseActions.hideNotifsList
        })
    }
}

function setNotifsCount(notifsCount) {
    return dispatch => {
        dispatch({
            type: courseActions.setNotifsCount,
            payload: notifsCount,
        })
    }
}

function setNotifList(notifs) {
    return dispatch => {
        dispatch({
            type: courseActions.setNotifList,
            payload: notifs
        })
    }
}


function getNotificationsApiSuccess(res) {
    return dispatch => {
        dispatch(setNotifList(res.data.notifications));
        dispatch(setNotifsCount(res.data.unseen_messages));
    }
}

function getNotificationsFromApi() {
    return (dispatch, getState) => {
        return ajaxJson.get('/users/new_site_notifications')
            .then(
                res => dispatch(getNotificationsApiSuccess(res)),
                err => dispatch(getNotificationsApiFail(err))
            )
    }
}


function getNotificationsApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseActions.setError,
            payload: err,
        })
    }
}

function setUnSeenMessages(unSeenMessages) {
    return dispatch => {
        dispatch({
            type: courseActions.setUnSeenMessages,
            payload: unSeenMessages,
        })
    }
}

function getUserInfoApiFail(err) {
    return dispatch => {
        dispatch({
            type: courseActions.setError,
            payload: err,
        })
    }
}

function getUserInfoApiSuccess(res) {
    return dispatch => {
        dispatch(setUnSeenMessages(res.data.unseen_messages))
    }
}

function getUserInfoFromApi() {
    return dispatch => {
        return ajaxJson.get('/users/info')
            .then(
                res => dispatch(getUserInfoApiSuccess(res)),
                err => dispatch(getUserInfoApiFail(err))
            )
    }
}

export const coursePageActionsCreators = {
    getCourseFromApi,
    setBreadCrumb,
    getProgramCourseAccessFromApi,
    toggleSearchState,
    getUserInfoFromApi,
    getNotificationsFromApi,
    toggleNotifsList,
    hideNotifsList
}

